import {
  createContext,
  useCallback,
  useContext,
  useState,
  useEffect,
  useMemo,
} from 'react';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const MediaCenterCategoriesContext = createContext({ categories: [] });

export default MediaCenterCategoriesContext;

export const useMediaCenterCategoriesContext = () =>
  useContext(MediaCenterCategoriesContext);

export const withMediaCenterCategoriesContext = (Component) => (props) => {
  const contextValue = useMediaCenterCategoriesContext();

  return <Component {...props} {...contextValue} />;
};

export const MediaCenterCategoriesProvider = ({ topic, children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState(null);
  const [error, setError] = useState(null);

  const getCategories = useCallback(() => {
    setIsLoading(true);

    axios
      .get(
        Routes.categories_media_center_v2_folders_path({ topic_id: topic?.id }),
      )
      .then(({ data: { categories } }) => {
        setCategories(categories);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!categories) {
      getCategories();
    }
  }, []);

  const providerState = useMemo(
    () => ({
      categories,
      error,
      isLoading,
    }),
    [categories, error, isLoading],
  );

  return (
    <MediaCenterCategoriesContext.Provider value={providerState}>
      {children}
    </MediaCenterCategoriesContext.Provider>
  );
};
